/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Nabis NY Web API
 * Nabis NY Web API docs
 * OpenAPI spec version: 1.0
 */
import axios from 'axios';
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import useSwr from 'swr';
import type { SWRConfiguration, Key } from 'swr';
import type {
  OrganizationMarketplaceSettingsResponseDto,
  OrganizationMarketplaceSettingsDto,
} from '../nabisNYWebAPI.schemas';

export const organizationMarketplaceSettingsControllerFindOneByOrganizationId = (
  organizationId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationMarketplaceSettingsResponseDto>> => {
  return axios.get(`/api/v1/organizations/${organizationId}/organization-marketplace-settings`, options);
};

export const getOrganizationMarketplaceSettingsControllerFindOneByOrganizationIdKey = (organizationId: string) =>
  [`/api/v1/organizations/${organizationId}/organization-marketplace-settings`] as const;

export type OrganizationMarketplaceSettingsControllerFindOneByOrganizationIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof organizationMarketplaceSettingsControllerFindOneByOrganizationId>>
>;
export type OrganizationMarketplaceSettingsControllerFindOneByOrganizationIdQueryError = AxiosError<unknown>;

export const useOrganizationMarketplaceSettingsControllerFindOneByOrganizationId = <TError = AxiosError<unknown>>(
  organizationId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof organizationMarketplaceSettingsControllerFindOneByOrganizationId>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    axios?: AxiosRequestConfig;
  },
) => {
  const { swr: swrOptions, axios: axiosOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!organizationId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getOrganizationMarketplaceSettingsControllerFindOneByOrganizationIdKey(organizationId) : null));
  const swrFn = () => organizationMarketplaceSettingsControllerFindOneByOrganizationId(organizationId, axiosOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const organizationMarketplaceSettingsControllerCreate = (
  organizationId: string,
  organizationMarketplaceSettingsDto: OrganizationMarketplaceSettingsDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationMarketplaceSettingsResponseDto>> => {
  return axios.post(
    `/api/v1/organizations/${organizationId}/organization-marketplace-settings`,
    organizationMarketplaceSettingsDto,
    options,
  );
};

export const organizationMarketplaceSettingsControllerUpdate = (
  organizationId: string,
  id: string,
  organizationMarketplaceSettingsDto: OrganizationMarketplaceSettingsDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationMarketplaceSettingsResponseDto>> => {
  return axios.put(
    `/api/v1/organizations/${organizationId}/organization-marketplace-settings/${id}`,
    organizationMarketplaceSettingsDto,
    options,
  );
};
